<template>
  <div class="table-header-cell">
    <dropdown
      :options="options"
      :value="value"
      :onChange="onChange"
      :placeholder="label"
      header=" Order by"
      mode="tableHeaderCell"
    />
  </div>
</template>

<script>
import Dropdown from './Dropdown';

export default {
  name: 'TableHeaderCell',
  props: {
    label: String,
    onChange: Function,
    options: Array,
    value: String,
  },
  components: {
    dropdown: Dropdown,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.table-header-cell {
  .material-select {
    padding: 0;
    min-width: auto;
  }

  ::v-deep .btn.btn-secondary {
    color: #c2c7d4;
    font-size: 13px !important;
    font-weight: 500;
    text-transform: uppercase;
    border: none !important;
    padding: 0;
    min-height: 40px;

    &:after {
      display: none;
    }
  }
  ::v-deep .dropdown-item {
    text-transform: none;
    user-select: none;
  }
}
</style>
